<div class="image-cropper-wrapper view overlay mr-auto ml-auto"
     [appAspectRatio]="editorMode || cssAspectRatio || rounded ? null : 0.5625"
     [class.crop-editor]="editorMode"
     [style.aspect-ratio]="cssAspectRatio"
     [ngStyle]="styles"
     [class]="{'zoom': hoverZoom, 'cursor-pointer': pointerEvents}">
  <div *ngxPermissionsOnly="permissions" class="toolbox-wrapper"
       [ngStyle]="{height: selectedImage ? 'unset' : '100px'}">
    <div *ngIf="toolboxEnabled" class="toolbox">
      <span class="label text-lg">{{ toolboxLabel }}</span>
      <app-end-cap
        *ngIf="!selectedImage"
        icon="pi pi-upload"
        [pointerClass]="'p-button-rounded p-button-text p-button-icon-only p-button-primary'"
        (onClickTrigger)="triggerFileUploadClick()">
      </app-end-cap>
      <ng-container *ngTemplateOutlet="selectedImgButtons"></ng-container>
      <app-end-cap
        *ngIf="!removeDisabled"
        icon="pi pi-trash"
        [pointerClass]="'p-button-rounded p-button-text p-button-icon-only p-button-danger'"
        (onClickTrigger)="triggerRemoveClick()">
      </app-end-cap>
    </div>
  </div>
  <div class="toolbox-wrapper">
    <ng-content></ng-content>
  </div>
  <div *ngIf="!selectedImage && imagePath"
       class="image-cropper"
       [appHeaderBackdrop]="showBackdrop && (imageFit === 'contain' || unpaddedImageUrl) && !rounded && !editorMode ? renderedImagePath : null"
       [style.background-color]="imageFit === 'contain' || unpaddedImageUrl ? 'var(--surface-ground)' : null"
  >
    <ng-container *ngIf="rounded; else defaultCropperImage">
      <div class="image-cropper-rounded-frame"
           [appHeaderBackdrop]="showBackdrop && (imageFit === 'contain' || unpaddedImageUrl) && !editorMode ? renderedImagePath : null">
        <ng-container *ngTemplateOutlet="defaultCropperImage"></ng-container>
      </div>
    </ng-container>
    <ng-template #defaultCropperImage>
      <img *ngIf="unpaddedImageUrl; else optimizedCropperImage" class="image-cropper__unpadded"
           [src]="unpaddedImageUrl" [alt]="toolboxLabel || ''" [style.object-fit]="'contain'">
    </ng-template>
    <ng-template #optimizedCropperImage>
      <img [alt]="toolboxLabel || ''" [ngSrc]="this.imagePath" [ngClass]="{'rounded': rounded}"
           [style.object-fit]="imageFit" [fill]="true"
           priority
      >
    </ng-template>
    <input style="display: none" type="file" accept="image/*" (change)="fileChangeEvent($event)" #fileInput/>
  </div>
  <image-cropper
    *ngIf="selectedImage"
    [class.edge-to-edge-cropper]="!rounded"
    [imageChangedEvent]="imageChangedEvent"
    [imageFile]="selectedImage"
    [aspectRatio]="aspectRatio"
    [maintainAspectRatio]="maintainAspectRatio"
    [resetCropOnAspectRatioChange]="true"
    [containWithinAspectRatio]="!editorMode"
    [onlyScaleDown]="true"
    [format]="format"
    [imageQuality]="imageQuality"
    [resizeToWidth]="effectiveResizeToWidth"
    [roundCropper]="rounded"
    [allowMoveImage]="true"
    [hideResizeSquares]="!editorMode"
    [alignImage]="'center'"
    (cropperReady)="cropperReady()"
    (imageLoaded)="imageLoaded($event)"
    (imageCropped)="onImgCropped($event)"
    (loadImageFailed)="onFail($event)"
    [(transform)]="transform"
    [backgroundColor]="'#1e1e1e'"
    [autoCrop]="false"
  ></image-cropper>

  <app-spinner [name]="'cropper'" *ngIf="spinnerState"></app-spinner>
  <div *ngIf="!toolboxEnabled && !externalControls && selectedImage" style="position: absolute; top:10px; right: 0; width: 50px; z-index: 2">
    <ng-container *ngTemplateOutlet="selectedImgButtons"></ng-container>
  </div>
  <div class="zoom-slider-wrap">
    <p-slider [ariaLabel]="'shared.image_lightbox.zoom_in' | translate" *ngIf="selectedImage" [(ngModel)]="scale" [step]="0.02" [min]="1" [max]="5"
              (onChange)="handleChange($event)"></p-slider>
  </div>
</div>

<ng-template #selectedImgButtons>
  <app-end-cap
    *ngIf="selectedImage"
    icon="pi pi-save"
    [pointerClass]="'p-button-rounded p-button-text p-button-icon-only p-button-primary'"
    (onClickTrigger)="cropImage()">
  </app-end-cap>
  <app-end-cap
    *ngIf="selectedImage"
    icon="pi pi-times"
    [pointerClass]="'p-button-rounded p-button-text p-button-icon-only p-button-warning'"
    (onClickTrigger)="cancelImgAdd()">
  </app-end-cap>
</ng-template>
